import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Platform } from '@ionic/angular';
import { forkJoin, from, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { FingerprintAuthConfiguration } from '../interfaces';
import { FingerprintService } from '../service/fingerprint.service';
import { Config } from '../tokens';

@Pipe({
  name: 'biometricLoginActive'
})
export class BiometricLoginActivePipe implements PipeTransform {

  constructor(
    private fingerprintService: FingerprintService,
    private platform: Platform,
    @Inject(Config) private readonly config: FingerprintAuthConfiguration
  ) { }

  transform(user: string): Observable<boolean> {
    this.config.debug && console.log('[BiometricLoginActive]', user)
    return from(this.platform.ready()).pipe(
      tap(() => this.config.debug && console.log('[BiometricLoginActive]', 'Platform is ready')),
      switchMap(() => {
        return forkJoin([
          this.fingerprintService.showFingerprintId(user, 'face'),
          this.fingerprintService.showFingerprintId(user, 'touch')
        ])
      }),
      tap(([face, touch]) => this.config.debug && console.log('[BiometricLoginActive]', 'Face:', face, 'Touch:', touch)),
      map(([face, touch]) => face || touch)
    )
  }

}
